import React from 'react';
import CourseOverview from './CourseOverview';
import Test from './Test';
import Training from './Training';

export default class UserView extends React.Component {

	constructor(props) {
		super(props);

        this.userID = this.props.userID;
        this.runningTest = false;
        this.navName = "courseOverview";
        this.state = { key: 0 };
    }

    logout() {
        this.props.handleLogoutEvent();
    }

    handleActiveTest() {
        this.runningTest = true;
    }
    handleFinishTest() {
        this.runningTest = false;
    }

    setNavText(text) {
        if (this.runningTest) {
            alert("Achtung!\nDu kannst den Testmodus nicht verlassen, bevor du alle Fragen beantwortet hast!");
        }
        else {
            this.navName = text;
            this.setState({ key: Math.random() });
        }
    }

    getRenderBlock() {
        if (this.navName === "courseOverview") {
            return (
                <CourseOverview firstname={ this.props.firstname } lastname={ this.props.lastname } sex={ this.props.sex } key={ this.state.key } CheckAuthError={ this.props.CheckAuthError } LogoutOnCookieNotSet={ this.props.LogoutOnCookieNotSet } userID={this.userID} />
            );
        }
        else if (this.navName === "training") {
            return (
                <Training key={ this.state.key } CheckAuthError={ this.props.CheckAuthError } LogoutOnCookieNotSet={ this.props.LogoutOnCookieNotSet } userID={this.userID}  />
            );
        }
        else if (this.navName === "test") {
            return (

                <Test key={ this.state.key } CheckAuthError={ this.props.CheckAuthError } LogoutOnCookieNotSet={ this.props.LogoutOnCookieNotSet } userID={ this.userID } hideNavbar={ this.handleActiveTest.bind(this) } showNavbar={ this.handleFinishTest.bind(this) }/>
            );
        }
    }
    render(){
        return (
            <div>
                <nav className="navbar navbar-default">
                    <div className="container">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            <a style={{fontSize: "14px"}} className="navbar-brand" href="https://www.medizinische-assistenzberufe.at">
                                <span style={{marginRight: "10px"}}><img className="navbar-image-container" src="./img/logo.jpg" alt="ForMed"></img></span>
                                Startseite
                            </a>
                        </div>

                        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                            <ul className="nav navbar-nav navbar-right">
                                <li><a className={(this.navName === "courseOverview") ? "active-nav" : "not-active-nav" } onClick={ () => this.setNavText("courseOverview")}>Kursübersicht</a></li>
                                <li><a className={(this.navName === "training") ? "active-nav" : "not-active-nav" } onClick={ () => this.setNavText("training") }>Fragentraining</a></li>
                                <li><a className={(this.navName === "test") ? "active-nav" : "not-active-nav" } onClick={ () => this.setNavText("test") }>Prüfung</a></li>
                                <li><a onClick={ () => this.logout() }>Logout</a></li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <main>
                    { this.getRenderBlock() }
                </main>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/user/UserView.js